import type {
	batchAddInput,
	batchUpdateInput,
	deleteMultipleProxiesInput,
	deleteOneInput,
	getAllProxiesInput,
	getProxiesFacetsInput,
	updateOneInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetProxies: getAllProxiesInput;
	useBatchUpdateProxies: batchUpdateInput;
	useDeleteMultipleProxies: deleteMultipleProxiesInput;
	useBatchAddProxies: batchAddInput;
	useDeleteSingleProxy: deleteOneInput;
	useUpdateProxy: updateOneInput;
	useGetProxyFacets: getProxiesFacetsInput;
}

const PROXY_SERVICE_KEYS = createReactQueryKeys<Keys>("proxy", [
	"useGetProxies",
	"useBatchUpdateProxies",
	"useDeleteMultipleProxies",
	"useBatchAddProxies",
	"useDeleteSingleProxy",
	"useUpdateProxy",
	"useGetProxyFacets",
]);

export { PROXY_SERVICE_KEYS };
